export default {
  common: {
    Add: 'Add',
    AddRow: 'Add Row',
    Verify: 'Verify',
    Export: 'Export',
    Import: 'Import',
    Search: 'Search',
    Reset: 'Reset',
    ResetPwd: 'Reset Pwd',
    OnLine: 'On Line',
    OffLine: 'Off Line',
    Operate: 'Operate',
    Modify: 'Modify',
    Delete: 'Delete',
    UpLoad: 'UpLoad',
    DownLoad: 'DownLoad',
    Copy: 'Copy',
    Confirm: 'Confirm',
    EnsureDelete: 'This data will be deleted',
    Cancel: 'Cancel',
    Ok: 'Ok',
    Y: 'Y',
    N: 'N',
    All: 'All',
    To: 'To',
    OneWeek: 'One Week',
    OneMouth: 'One Mouth',
    ThreeMouth: 'Three Mouth',
    Tips: 'Tips',
    Normal: 'Normal',
    Disable: 'Disable',
    Recovery: 'Recovery',
    Close: 'Close',
    Draft: 'Draft',
    Edit: 'Edit',
    Save: 'Save',
    UserRegistration: 'User Registration',
    AdministratorAdd: 'Administrator Add',
    Choose: 'Choose',
    Check: 'Check',
    Sex: 'Sex',
    OnSale: 'OnSale',
    NoSale: 'NoSale',
    Customize: 'Customize',
    Default: 'Default',
    System: 'System',
    SystemName: 'System Name',
    Serial: 'SN',
    Code: 'Code',
    Name: 'Name',
    Value: 'Value',
    Type: 'Type',
    Remark: 'Remark',
    Status: 'Status',
    Valid: 'valid',
    StartTime: 'Start Time',
    EndTime: 'End Time',
    StartDay: 'Start Day',
    EndDay: 'End Day',
    ModifyUser: 'Modify User',
    ModifyTime: 'Modify Time',
    ModifyTimeDetail: 'Modify Time Detail',
    NoData: 'No Data',
    Refresh: 'Refresh',
    No: 'No',
    Publish: 'Publish',
    NoPublish: 'No Publish',
    CreateTime: 'Create Time',
    BasicInformation: 'Basic Information',
    AccountingInformation: 'Accounting Information',
    FinancialInformation: 'Financial Information',
    BusinessInformation: 'Business Information',
    AccountTips: 'Login account can be numbers, letters, underscores',
    DiscountTips: 'The default is 10 without discount (for example: 9.2 fold, fill in 9.2)',
    basicInformation: 'Basic Information',
    Account: 'Account',
    Pwd: 'Pwd',
    DeleteConfirm: 'Are you sure you want to delete it?',
    RecoverConfirm: 'Are you sure you want to recover it?',
    DisableConfirm: 'Are you sure you want to disable it?',
    DeleteCancelResult: 'Command cancelled !',
    FromBackEnd: 'From Admin',
    FromFrontEnd: 'From Web',
    // 产品相关
    ProductCode: 'Product Code',
    ProductName: 'Product Name',
    Quantity: 'Quantity',
    Unit: 'Unit',
    Price: 'Price',
    Password: 'Password',
    UploadPicture: 'Upload Picture',
    UploadQRCode: 'Upload QRCode',
    PleaseChoose: 'Please Choose',
    PictureURLCanNotBeEmpty: 'Picture URL Can Not Be Empty',
    RelatedProduct: 'Related Product',
    DeleteTips: 'Please Choose The Data You Want To Delete',
    VerifyTips: 'Whether The Audit Passed',
    Approved: 'Approved',
    NotApproved: 'Not Approved',
    Province: 'Province',
    City: 'City',
    Area: 'Area',
    Man: 'Man',
    TaxNo: 'TaxNo',
    Telephone: 'Tel',
    Woman: 'Woman',
    Birthday: 'Birthday',
    ZipCode: 'ZipCode',
    InvoiceInformation: 'Invoice Information',
    Contacts: 'Contacts',
    Mobile: 'Mobile',
    Tel: 'Tel',
    RetailPrice: 'RetailPrice',
    FirstPrice: 'FirstPrice',
    SecondPrice: 'SecondPrice',
    ThirdPrice: 'ThirdPrice',
    Fourth: 'Fourth',
    FifthPrice: 'FifthPrice',
    Address: 'Address',
    ComeFrom: 'ComeFrom',
    Regtime: 'Regtime',
    CheckPending: 'CheckPending',
    MaxWords: 'Up to 90 words',
    RegionEmpty: 'Region can not be empty',
    AgentEmpty: 'AgentName can not be empty',
    NotEmpty: 'Can not be empty',
    CorrectAccountNumber: 'Please enter the correct account number',
    CorrectMobile: 'Please enter the correct mobile',
    CorrectFormat: 'Please enter the correct format',
    SalesmenEmpty: 'Salesmen can not be empty',
    WechatCode: 'Wechat Code',
    WechatName: 'Wechat Name',
    RefereeCode: 'Referee Code',
    RefereeName: 'Referee Name',
    OverLength: 'Over Length',
    GoodsNo: 'Goods No',
    AuditStatus: 'Audit Status'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/common.js